import PING_AI_API from '@/shared/api/queries/pingAiApi';
import type { PingAiApiQuery, PingAiApiQueryVariables } from '@/shared/api/generated/graphql';
import createClient from '../client/apolloClient';

/**
 * Signals the AI backend that the user is still active on a profile and tab. Runs the ping query and discards its result.
 *
 * @param profileId - Profile the user is working on.
 * @param tab - Tab currently open; omitted while migrating.
 * @returns A promise resolving once the ping has been sent.
 */
const pingAiApi = async (profileId: string, tab?: string) => {
  const client = await createClient();
  await client.query<PingAiApiQuery, PingAiApiQueryVariables>({
    query: PING_AI_API,
    variables: {
      profileId,
      tab,
    },
  });
};

export default pingAiApi;
